export class CaseFlagModel {
  public id: number;
  public name: string;
  public color: string;
  public description: string;
  public caseTypeIds: number[];
}
